module.exports = __webpack_public_path__ + "static/media/grid-metro-1.ac78f581.jpg";